"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnboarding = exports.ONBOARDING_AVAILABLE_FROM = void 0;
const permissions_pool_1 = require("@app/const/permissions-pool");
const store_1 = require("@app/store");
const moment_1 = __importDefault(require("moment"));
const is_defined_1 = require("../is-defined");
const useAccessRole_1 = require("./useAccessRole");
const useWorkspace_1 = require("./useWorkspace");
/**
 * Cut-off for the onboarding checklist: only workspaces created at or after this moment
 * ever see it.
 *
 * The design calls this screen "Nový zákazník", and there is no server-side flag that says
 * whether a workspace has been through onboarding — `creationMetadata` is write-once at
 * creation time and old workspaces have it all-null, so it cannot tell a fresh workspace
 * from a 2024 one. Creation date can. Every existing customer's workspace predates this
 * date by years, so nobody who is already running their operation is ever shown a
 * "let's set up your operation" checklist.
 *
 * Deliberately a date in the PAST, not the deploy date, and it must stay that way. A future
 * value makes nothing eligible — `registration.cy.ts` asserts that a genuinely new account
 * lands on `/onboarding`, which cannot be faked, and those specs gate staging deploys on
 * master, so a future date turns CI red until it arrives. The only accounts a slightly-early
 * cut-off catches are ones created in the days just before the deploy, which are new
 * workspaces that should see the checklist anyway.
 */
exports.ONBOARDING_AVAILABLE_FROM = '2026-08-20T00:00:00.000Z';
const useOnboarding = () => {
    const { canWrite } = (0, useAccessRole_1.useAccessRole)();
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const workspaceId = (0, store_1.useRootSelector)((state) => state.workspaceId) ?? undefined;
    const flags = (0, store_1.useRootSelector)((state) => (0, is_defined_1.isValue)(workspaceId) ? state.onboarding[workspaceId] : undefined);
    const created = workspace?.created;
    const isNewWorkspace = (0, is_defined_1.isValue)(created) && !(0, moment_1.default)(created).isBefore(exports.ONBOARDING_AVAILABLE_FROM);
    // every step of the checklist is a manager action, and the calendar write permission is
    // the one none of them can be done without
    const isEligible = isNewWorkspace && canWrite(permissions_pool_1.PERMISSIONS.CALENDAR) && flags?.hidden !== true;
    return {
        workspaceId,
        isEligible,
        shouldLand: isEligible && flags?.dismissed !== true,
    };
};
exports.useOnboarding = useOnboarding;
